import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import Header from "src/Component/content-component/Header";
import studentWorkData from "./StudentExchangeProgramWorkData";

const StyledCard = styled(Card)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: "10px",
  width: "260px",
  height: "280px",
  borderRadius: "12px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
});

const StudentWork = () => {
  return (
    <Box
    id='student-exchange-semester-abroad'
      sx={{ textAlign: "center", mt: 8, mb: 5, px: { xs: 2, sm: 5, md: 10 } }}
    >
      <Header
        content={"How Our Student Exchange Programme Works?"}
        color="#00999E"
        sx={{ mb: 1 }}
      />

      <Grid container spacing={3} justifyContent="center" sx={{ mt: 5 }}>
        {studentWorkData.map((WorkData, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <StyledCard>
              <Box sx={{ fontSize: 40, color: "#008080", mt: 2 }}>
                <img
                  src={WorkData?.Image}
                  alt="EligibilityImage"
                  style={{
                    borderRadius: "50%",
                    width: "100px",
                    height: "100px",
                  }}
                />
              </Box>
              <CardContent>
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: WorkData.title }}
                />
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StudentWork;
